import ICidade from '../../interfaces/ICidade';
import IDistrito from '../../interfaces/IDistrito';
import IDistritoParaSelect from '../../interfaces/IDistritoParaSelect';

export const mapearDistritosDaCidadeParaSelect = (cidade: ICidade, distritos: IDistrito[]): IDistritoParaSelect[] =>
  distritos.filter(distrito => distrito.cidade.id == cidade?.id).map(({ id, nome }) => ({
    value: id,
    label: nome
  }));